import { getPublicRouteUrl } from '@nackle/service-urls';

let env = window.location.hostname
  .toLowerCase()
  .split( '.' )
  .find(
    ( chunk ) => [ 'ci', 'dev', 'qa', 'pprd', 'localhost' ].indexOf( chunk ) >= 0
  );

if ( env === 'localhost' ) {
  env = 'qa';
}

function getURL( url ) {
  return url.toLowerCase().replace( '(env.)', env ? env + '.' : '' );
}

export const idURL = getPublicRouteUrl( 'ID_PROVIDER' );
export const serviceAwardsURL = getPublicRouteUrl( 'SERVICE_AWARDS' );
export const rosterURL = getPublicRouteUrl( 'ROSTER_PROXY' );
export const cmxURL = getPublicRouteUrl( 'CMX_SERVICE_V2' );
export const serviceAwardsStudioURL = getURL( 'https://(env.)service-awards-studio.biw.cloud' );
